import React, { AriaAttributes, AriaRole } from "react";
import { twMerge } from "tailwind-merge";
import { Section } from "@sizdevteam1/funjoiner-uikit";

export const PaymentMethodListTile = ({
  title,
  description,
  trailing,
  className,
  onClick,
  ...rest
}: {
  title: (id: string) => React.ReactNode;
  description?: React.ReactNode;
  trailing?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  role?: AriaRole;
} & AriaAttributes) => {
  const props =
    onClick != null
      ? ({
          as: "button",
          onClick: onClick,
        } as const)
      : ({
          as: "section",
        } as const);
  return (
    <Section
      {...props}
      data-cy="payment-method-list-tile"
      className={twMerge(
        "flex w-full flex-col gap-3 rounded-[10px] border-[1px] border-solid border-separator-color bg-on-main-color p-4 shadow-big",
        className,
        onClick != null && "cursor-pointer",
      )}
      {...rest}
    >
      {(labelId) => (
        <>
          <div className={"flex flex-row gap-2"}>
            <div className={"flex-1"}>{title(labelId)}</div>
            {trailing}
          </div>
          {description}
        </>
      )}
    </Section>
  );
};
